import { App } from 'antd';
import { http } from 'services/http';
import { CLIENT_INSURANCE, CLIENT_INSURANCE_HISTORY } from 'api/query-keys';
import type { TClientInsuranceRes, TUploadClientInsuranceReq } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base';

interface IUploadClientInsuranceVariables extends TUploadClientInsuranceReq {
  clientId: number;
  file: File;
}

export const useUploadClientInsurance = () => {
  const { message } = App.useApp();

  return useMutationBase<TClientInsuranceRes, unknown, IUploadClientInsuranceVariables>({
    mutationFn: async ({ clientId, file, validFrom, validTo }) => {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('validFrom', validFrom);
      formData.append('validTo', validTo);

      const { data } = await http.post<TClientInsuranceRes>(`/v1/clients/${clientId}/insurance`, formData);
      return data;
    },
    invalidateCallback: (_, variables) => [
      [CLIENT_INSURANCE, variables.clientId],
      [CLIENT_INSURANCE_HISTORY, variables.clientId],
    ],
    onSuccess: () => {
      message.success('Insurance uploaded successfully');
    },
  });
};
